import React from 'react';
import Button from '@material-ui/core/Button';
import { OrderDetailInfo } from './order-detail-list.component';
import { DefaultRequest } from '../requests/default.request';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import Store from '../redux/store';
import { getSettingInfo } from '../tools/get-setting-info';
import _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import { HistoryDish, TableStatus } from '../constants/type.constant';
import CustomizedTooltips from './tooltip.component';
import { WebsocketClient } from '../websocket/module';
import i18n from '../i18n';
import { StateManager } from '../redux/stateManager';
import { getCacheField } from '../tools/get-cache-field';
import ServerShoppingCart from '../modules/server-shopping-cart';

// 顾客id
class SelectCustomId extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    public resultTableStatus: TableStatus[] = [];
    // 已下单菜品状态显示
    public dishStatusType: number = getSettingInfo('order_menu_status', 'value') || 0;
    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.state = {
            // 历史记录
            roundlist: [],
            // 顾客
            customers: [],
            // 全部顾客及其点的全部菜品
            roundlistAll: {},
            // 提示框显隐
            showTip: true,
            // 全部历史记录
            allDish: []
        }
    }
    // *********************
    // 生命周期
    // *********************
    public async componentDidMount() {
        // 获取历史记录
        this.getOrders();
        // 获取客户id列表
        this.getGenerateCustomerName()
        // 1.5s后关闭提示
        setTimeout(() => {
            this.setState({
                showTip: false
            })
        }, 1500)
    }

    public componentWillUnmount() {
        this.setState = (state, callback) => { return; };
    }

    /**
    * 获取历史记录
    */
    public async getOrders() {
        try {
            // 从缓存中拿
            const menuId = getSettingInfo('package-fee', 'value').menu_id;
            const historyDish = await DefaultRequest.getHistoryDish(getCacheField('orderTab.orderId'), menuId, 'round,dish,type,rule')
            let roundlistAll: State['roundlistAll'] = {};
            Object.values(historyDish.round_customer_dish_data).forEach((item) => {
                _.forEach(item, (value, key) => {
                    if (key) {
                        if (_.hasIn(roundlistAll, key)) {
                            roundlistAll[key] = _.concat(roundlistAll[key], value)
                        } else {
                            roundlistAll[key] = value;
                        }
                    }
                })
            });
            if (roundlistAll !== {}) {
                const allDish = historyDish.type_round_dish ? historyDish.type_round_dish.all.all : [];

                const roundlist = allDish && allDish.length ? _.reverse(_.takeRight(allDish, 10)) : [];
                this.setState({
                    roundlist,
                    roundlistAll,
                    allDish: roundlist,
                })
            }

        }
        catch (error) {
            console.log(error)
        }
    }

    /**
     * 获取id列表
     */
    public async getGenerateCustomerName() {
        // 缓存中的桌台状态
        this.resultTableStatus = StateManager.getFromCache('tableStatusById');
        if (_.isEmpty(this.resultTableStatus)) {
            this.resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
            // 当前桌台状态存入缓存
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'tableStatusById',
                value: this.resultTableStatus,
            })
        }
        const PERSON = _.get(this.resultTableStatus, '0.customer_num', 1);
        // const ORDERID = getCacheField('orderTab.orderId');
        // let generateCustomerName = await DefaultRequest.getGenerateCustomerName(ORDERID);
        let count = 1;
        let personArr: string[] = [];
        if (PERSON) {
            for (let i = 0; i < PERSON; i++) {
                personArr.push((count++).toString());
            }
        } else {
            personArr = StateManager.getFromCache('personArr')
        }
        // let { auto_customer_name = [], } = generateCustomerName;

        // let personArr: string[] = StateManager.getFromCache('personArr');

        // 由于（聚客）修改人数 getGenerateCustomerName接口返回跟 不能同步，需要额外做人数判断
        let customers = personArr.map((item) => ({ id: item, selected: false }))
        if (customers.length) {
            this.setState({ customers })
        } else {
            personArr.forEach((element: string, index: number) => {
                _.set(customers, `${index}.id`, element);
                _.set(customers, `${index}.selected`, false);
            });
            this.setState({ customers })
        }
    }

    /**
     * 确认id
     */
    public confirm = () => {
        const { customers } = this.state;
        let customerSelected = _.find(customers, ['selected', true]);
        if (customerSelected) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab.customer',
                value: customerSelected.id
            })
            // 往所有加入此订单的客户端发送自己的id信息
            WebsocketClient.emitOrderClients({
                event: 'CUSTOMER_ID',
                customer: customerSelected.id,
            })
            // $ 分配顾客ID后, 触发轮次统计方法
            WebsocketClient.emit('DISTRIBUTION_ID', { customer: customerSelected.id })
            // 新手指引提示气泡
            WebsocketClient.emit('BUBBLE_PROMPT')
            // $ 连接服务端购物车
            let users = ServerShoppingCart?.metaData?.users || [];
            let user = _.find(users, (n) => n.userName === customerSelected?.id);
            ServerShoppingCart.connetSeverShoppingCart({
                cartFind: {
                    id: ServerShoppingCart?.metaData?.id,
                    orderId: getCacheField('orderTab.orderId') ? `${getCacheField('orderTab.orderId')}` : undefined,
                },
                user,
            })
        }
    }

    /**
     * 选中id
     */
    public selectCustom = (id: string) => {
        const { customers } = this.state;
        customers.forEach((item) => {
            if (item.id === id) {
                item.selected = !item.selected
                if (item.selected) {
                    // 显示选中顾客的历史记录
                    this.updateRoundlist(item.id);
                } else {
                    // 显示选中顾客的历史记录
                    this.updateRoundlist(undefined);
                }
            } else {
                item.selected = false
            }
        })
    }

    /**
     * 显示选中顾客的历史记录
     * @param customer 选中的顾客
     */
    public updateRoundlist(customer: string | undefined) {
        const { roundlistAll, allDish } = this.state;
        let roundlist: HistoryDish[] = [];
        if (customer) {
            roundlist = roundlistAll[customer] && roundlistAll[customer].length > 0 ? _.reverse(_.takeRight(roundlistAll[customer], 10)) : []
        } else {
            roundlist = allDish;
        }
        this.setState({
            roundlist,
        })
    }

    render() {
        const { roundlist, customers, showTip } = this.state;
        let customerSelected = _.find(customers, ['selected', true]);
        let isInterfaceSwitch = getCacheField('isInterfaceSwitch');
        return (
            <div className="selectCustomId">
                <div className="selectTop">
                    <div className="selectTitle">
                        {i18n.t('menu_page_text_please_select_your_id')}
                    </div>
                    <div className="customersDiv">
                        <Grid container spacing={2}>
                            {
                                customers.map((item, index) => (
                                    <Grid item xs={4} key={index}>
                                        <Button
                                            onClick={() => {
                                                this.selectCustom(item.id)
                                            }}
                                            fullWidth
                                            className={item.selected ? 'themeColor customerItem active' : 'themeColor customerItem'}>
                                            {item.id}
                                        </Button>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </div>
                    <Button
                        onClick={this.confirm}
                        className={customerSelected ? 'aiderColor confirmBtn active' : 'aiderColor confirmBtn'}
                    >
                        {i18n.t('general_button_sure')}
                    </Button>
                </div>
                <div className="selectBottom">
                    {
                        roundlist.map((item, index) => (
                            <CustomizedTooltips
                                key={index}
                                arrow
                                placement="bottom"
                                open={showTip && index === 1}
                                title={`${i18n.t('menu_page_text_check_tip_id')}`}
                            >
                                < OrderDetailInfo
                                    item={item}
                                    isInterfaceSwitch={isInterfaceSwitch}
                                    dishStatusType={this.dishStatusType}
                                />
                            </CustomizedTooltips>
                        ))
                    }

                </div>
            </div>
        )
    }
}

export default withSnackbar(SelectCustomId)

type Props = {

} & WithSnackbarProps

type State = {
    // 历史记录
    roundlist: Array<HistoryDish>
    // 顾客
    customers: Array<{
        id: string
        selected: boolean
    }>
    // 全部顾客及其点的全部菜品
    roundlistAll: {
        [cutomer_name: string]: Array<HistoryDish>;
    }
    // 提示框显隐
    showTip: boolean
    // 全部历史记录
    allDish: Array<HistoryDish>
}